import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KalturaLogger } from '@kaltura-ng/kaltura-logger';
import { BrowserService } from 'app-shared/kmc-shell/providers/browser.service';
import { Title } from '@angular/platform-browser';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { ContextualHelpService } from 'app-shared/kmc-shared/contextual-help/contextual-help.service';
import { KmcMainViewBaseService, ViewMetadata } from '../kmc-main-view-base.service';
import { KMCPermissions, KMCPermissionsService } from '../../kmc-permissions';

@Injectable()
export class AdminRolesMainViewService extends KmcMainViewBaseService {
  constructor(
    logger: KalturaLogger,
    browserService: BrowserService,
    router: Router,
    private _appPermissions: KMCPermissionsService,
    appLocalization: AppLocalization,
    titleService: Title,
    contextualHelpService: ContextualHelpService,
  ) {
    super(
      appLocalization,
      logger.subLogger('AdminRolesMainViewService'),
      browserService,
      router,
      titleService,
      contextualHelpService,
    );
  }

  isAvailable(): boolean {
    return (
      this._appPermissions.hasPermission(KMCPermissions.ADMIN_BASE) &&
      this._appPermissions.hasAnyPermissions([
        KMCPermissions.ADMIN_ROLE_ADD,
        KMCPermissions.ADMIN_ROLE_UPDATE,
        KMCPermissions.ADMIN_ROLE_DELETE,
      ])
    );
  }

  getRoutePath(): string {
    return 'administration/roles';
  }

  getViewMetadata(): ViewMetadata {
    return {
      viewKey: 'admin-roles',
      title: this._appLocalization.get('app.titles.administrationRolesPageTitle'),
      menu: this._appLocalization.get('app.titles.administrationRolesMenuTitle'),
    };
  }
}
